import React, {useState, useEffect} from 'react'
import styled, { keyframes } from 'styled-components';
import { fetchWrapper } from '../../utils/apiHandlers';
import Button from '../Button';
import SmallButton from '../SmallButton';
import TextboxComp from '../TextboxComp';
import MessageModal from '../MessageModal';
import HorizontalLine from '../horizontalLine';
import ConfirmModal from '../ConfirmModal';
import { MdEdit, MdCancel } from "react-icons/md";
import InputComp from '../InputComp';
import LoadingComponent from '../LoadingComponent';
import { Router } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import EditContext from '../EditContext';
// import ConfirmModal from '../ConfirmModal';

interface Prop{
  userid: string;
}
const ProductInfoComp : React.FC<Prop>=({userid})=>{
    const history = useHistory()

	const [ topic, settopic ] = useState("")	
	const [ context, setcontext ] = useState("")	
	const [ contexts, setcontexts ] = useState<any>([])	

	const [ modalstate, setmodalstate ] = useState(false)
	const [ modalheader, setmodalheader ] = useState("")
	const [ modalmessage, setmodalmessage ] = useState("")
	const [ modalprogress, setmodalprogress ] = useState(false)
	const [ loading, setloading ] = useState(false)
	const [ user, setuser ] = useState<any>(null)
	const [ selecteditem, setselecteditem ] = useState(null)
	const [ editmodalstate, seteditmodalstate ] = useState(false)	
	const [ confirmmodalstate, setconfirmmodalstate ] = useState(false)

	const [ deleteid, setdeleteid ] = useState("")
	

	const confirmyesfunc = async (id: any) => {
		// await deletecontext(id)
		setloading(true)

		try{
			let response = await fetchWrapper.post("/api/context/deletecontext", {id:deleteid})
		}catch(error){

		}
		await getcontexts()
		seteditmodalstate(false)
		setloading(false)
		setconfirmmodalstate(false)
	}

	
	const editcontext = (id: any) => {
		setselecteditem(contexts[id])
		seteditmodalstate(true)
	}

	const addcontext = async () => {
		if(topic==""){
			openModal("Warning", 'Title is required', false)
			return
		}
		if(context.length<50){
			openModal("Warning", 'Your description is too short. Description should be at least 50 characters', false)
			return
		}
		setloading(true)
		try{
			let response = await fetchWrapper.post("/api/context/addcontext", {userid:user.userid, topic:topic, context: context})
			settopic("")
			setcontext("")
			openModal("Message", response.msg, false)
		}catch(error){
			openModal("Warning", `${error}`, false)
		}
		await getcontexts()
		setloading(false)		
	}

	const getcontexts = async () => {
		setloading(true)
		try{
			let response = await fetchWrapper.post("/api/context/getcontexts", {userid:user.userid})
			setcontexts(response.contexts)
		}catch(error){

		}
		setloading(false)
	}

	const deletecontext = async (id: any) => {
		setdeleteid(id)
		setconfirmmodalstate(true)
	}

	const updatecontext = async (id: any, context: any) => {
		setloading(true)
		try{
			await fetchWrapper.post("/api/context/updatecontext", {id:id, context: context})
		}catch(error){

		}
		await getcontexts()
		seteditmodalstate(false)
		setloading(false)
	}

	const openModal = (header: any, message: any, progress?: any) => {
		setmodalheader(header)
		setmodalmessage(message)
		progress?setmodalprogress(true): setmodalprogress(false)
		setmodalstate(true)
	}


	useEffect(()=>{
		let user = JSON.parse(localStorage.getItem('user')||'{}')
		if(!user||user.status!==200){
			history.push("/login")
			return
		}
		setuser(user)
	}, [user])

	useEffect(()=>{
		
	}, [])
  

  return(
	<MainContainer>
		<EditContext item={selecteditem} state={editmodalstate} handleClose={()=>seteditmodalstate(false)} update={updatecontext} deleteitem={deletecontext}/>
		<MessageModal state={modalstate} header={modalheader} message={modalmessage} progress={modalprogress} handleClose={()=>setmodalstate(false)} />
		
		<ConfirmModal state={confirmmodalstate} func={confirmyesfunc} header="Confirm" message='Are you sure you want to delete item?'handleClose={()=>setconfirmmodalstate(false)} />

		<Column >
			<SubHeader>Product Information</SubHeader>
			<Description>Enter your product information along with specific queries that your customers experience. This is information is used to train LLM and used to answer questions from your customers</Description>
			{loading?<LoadingComponent />:<></>}

			<InputComp id="contexttypeid" value={topic} placeholder='product or query title' onChange={(e: any)=>settopic(e.target.value)} />
			<TextboxComp id="context_tb_id" value={context} onChange={(e: any)=> setcontext(e.target.value)} placeholder={`Enter product or query description (minimum 50 characters)`} rows={5} cols={10} width={500} />
			<ButtonContainer>
				<Button text='insert' handleClick={()=>addcontext()} />
				<Button text='load' handleClick={()=>getcontexts()} />
			</ButtonContainer>
			{
				contexts.map((v:any, id: any)=>(
					<QAColumn id={`id_${id}`} key={`id_${id}`} style={{alignItems:"flex-start"}}>
						<Row style={{fontWeight: 700}} >{id+1}. Title: {v.topic}&nbsp; <MdEdit color={"black"} onClick={()=>editcontext(id)} />
						</Row>
						<Row style={{whiteSpace:"pre", textWrap:"wrap", lineHeight: 1.5}} >Description: {v.context}</Row>
					</QAColumn>
				))
			}
		</Column>
    </MainContainer>
  );
}

const showAnimation = keyframes`
0% {
    opacity: 0
  }
  50% {
    opacity: 0.5
  }
  100% {
    opacity: 1;
  }
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(90deg);
  }
}`;

const Description = styled.p`
	padding: 7px;
	line-height: 1.5;
	font-size: 14px;
	font-weight: 500;
	width: 75%;
`;

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  align-items: center;
  width: 100%;
`

const RowHead = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  margin: 0px;
  padding: 7px;
  border-bottom: 1px solid black;
  @media (max-width: 770px) {
    flex-direction: column;
  }
`

const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  margin: 0px;
  padding: 7px;

`
const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  color: #000;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  @media (max-width: 770px) {
    padding: 20px 50px;
  }
`
const QAColumn = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	color: #000;
	justify-content: flex-start;
	align-items: flex-start;
	width: 100%;
	z-index: 1;
	padding: 20px;
    @media (max-width: 770px) {
  	}
	  &:hover{
    	background-color: #eee;
  	}
`

const Header = styled.div`
    padding: 10px;
    font-weight: 700;
    font-size: 40px;
    justify-content: flex-end;
    color: black;
`;

const SubHeader = styled.div`
    padding: 10px;
    font-weight: 700;
    font-size: 30px;
    justify-content: flex-end;
    color: black;
`;

const Item = styled.div`
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0;
    margin: 0;
    font-weight: 500;
    font-size: 14px;
    color: black;
`;

const QuestionContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    color: black;
    animation: ${showAnimation} 0.5s linear;
    width: 100%;
`;

const AnswerContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    color: black;
    width: 100%;
`;

const Question = styled.span`
    // display: flex;
    width: 100%;
    font-weight: 400;
    font-size: 18px;
    justify-content: flex-end;
    color: black;
    cursor: pointer;

`;
const Answer = styled.div`
    margin: 10px 0 0 0;
    font-weight: 400;
    font-size: 15px;
    justify-content: flex-end;
    line-height: 2;
    color: black;
`;

const ButtonContainer = styled.div`
  display: flex;
`;

export default ProductInfoComp

